import { roleplayCardHistoryItemStyles } from '../../../RoleplayCard.styles';
import { SkeletonLoader } from '@/components/Loaders';

/**
 * Roleplay card history item date/time component is responsible for displaying
 * the date and time of a roleplay session in the history item. It also handles
 * the loading state by showing skeleton loaders when the data is being fetched
 * or processed.
 */
export const RoleplayCardHistoryItemDateTime: React.FC<{
  date: string;
  time: string;
  isLoading: boolean;
}> = ({ date, time, isLoading }) => {
  /** Loader component for displaying skeletons while data is loading */
  const LoaderProvider = () => {
    return <SkeletonLoader width="full" rounded="none" className="h-[20px]" />;
  };

  // ============================
  // Render
  // ============================
  return (
    <div className={roleplayCardHistoryItemStyles.timeCompleted}>
      <div className={roleplayCardHistoryItemStyles.sessionDate}>
        {isLoading ? <LoaderProvider /> : date}
      </div>
      <div className={roleplayCardHistoryItemStyles.sessionTime}>
        {isLoading ? <LoaderProvider /> : time}
      </div>
    </div>
  );
};
